<template>
  <button
    :disabled="$store.state.general.localLoadingSpinner ? true : disabled"
    :class="classList"
    @click="$emit('click')"
  >
    {{ label }}
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { twMerge } from 'tailwind-merge';

interface TButtonProps {
  label?: string;
  disabled?: boolean;
  color?: 'white' | 'indigo' | 'black' | 'red' | 'amber';
  size?: 'sm' | 'md' | 'lg';
}

const { label, disabled = false, color = 'white', size = 'md' } = defineProps<TButtonProps>();

const emit = defineEmits(['click']);

const classList = computed(() => {
  return twMerge(baseClassList.value, disabledClassList.value, sizeClassList.value);
});

const baseClassList = computed(() => {
  if (color === 'white') {
    return `w-full sm:w-auto justify-center inline-flex items-center border border-gray-300 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`;
  } else if (color === 'indigo') {
    return `w-full sm:w-auto justify-center inline-flex items-center border border-transparent font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`;
  } else if (color === 'black') {
    return `w-full sm:w-auto justify-center inline-flex items-center border border-transparent font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500`;
  } else if (color === 'red') {
    return `w-full sm:w-auto justify-center inline-flex items-center border border-transparent font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500`;
  } else if (color === 'amber') {
    return `w-full sm:w-auto justify-center inline-flex items-center border border-transparent font-medium rounded-md text-slate-900 bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900`;
  }
});

const disabledClassList = computed(() => {
  return disabled ? 'opacity-30 cursor-not-allowed' : '';
});

const sizeClassList = computed(() => {
  if (size === 'sm') {
    return 'px-2 py-1 text-xs';
  } else if (size === 'md') {
    return 'px-4 py-2 text-sm';
  } else if (size === 'lg') {
    return 'px-6 py-3';
  }
});
</script>
